import React, {useEffect, useState, useRef} from 'react'
import { Button, Card, Container } from 'reactstrap'
import "assets/css/horizontal.css"

const tours = [
    {
        id:'1',
        src:require("assets/img/KTSImages/Images/MsaTours/Classic5dayItineraryfromMombasa.JPG"),
        caption:"Classic Kenyan Tour",
        location:"Kenya",
        url:'/kenya/mombasa/classic-tour'
    },
    {
        id:'2',
        src:require("assets/img/KTSImages/Images/NrbTours/TheGrandSafari(2).JPG"),
        caption:"The Grand Safari",
        location:"Kenya",
        url:'/kenya/nairobi/the-grand-safari'
    },
    {
        id:'3',
        src:require("assets/img/KTSImages/Images/Gallery/Gallery15.JPG"),
        caption:"Secrets of Africa",
        location:"Kenya - Tanzania",
        url:'/cross-country/secrets-of-africa1'
    },
    {
        id:'4',
        src:require("assets/img/KTSImages/Images/Gallery/Gallery13.JPG"),
        caption:"Serengeti Fly-In",
        location:"Tanzania",
        url:'/tanzania/serengeti-fly-in'
    },
    {
        id:'5',
        src:require("assets/img/KTSImages/Images/NrbTours/RedMudAmboseli(1).JPG"),
        caption:"Red Mud Safari",
        location:"Kenya",
        url:'/kenya/nairobi/red-mud-safari'
    },
    {
        id:'6',
        src:require("assets/img/KTSImages/Images/NrbTours/MasaiMaraAndNakuruPackage(1).JPG"),
        caption:"The Kenyan Safari",
        location:"Kenya",
        url:'/kenya/nairobi/kenyan-safari'
    }
]

function HorizontalScroll() {

    let scrl = useRef(null)
    const [scrollX,setScrollX] = useState(0);
    const [scrollEnd, setScrollEnd] = useState(false);

    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setScrollX(scrollX + shift);

        if(
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ){
            setScrollEnd(true)
        }
        else{
            setScrollEnd(false)
        }
    }

    const scrollCheck = () => {
        setScrollX(scrl.current.scrollLeft);
        if (
          Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
          scrl.current.offsetWidth
        ) {
          setScrollEnd(true);
        } else {
          setScrollEnd(false);
        }
    };

    useEffect(()=>{
        if(scrl.current && scrl?.current?.scrollWidth === scrl?.current?.offsetWidth){
            setScrollEnd(true);
        }
        else{
            setScrollEnd(false);
        }
        return()=>{};
    }, [scrl?.current?.scrollWidth, scrl?.current?.offsetWidth])

    return (
        <>
        <Container style={{marginTop:'2%'}}>
            <h2 className='title text-center'>Our Top Tours</h2>
            <div className='scrollContainer'>
                {scrollX !== -1 && (
                    <div className='arrow-left' style={{marginTop:'-5%'}}>
                        <Button type='button' onClick={()=>slide(-300)} color='neutral'>
                            <i className='now-ui-icons arrows-1_minimal-left'/>
                        </Button>
                    </div>
                )}

                <div className='horizontalscroll' ref={scrl}>
                    <div className='ul-parent'>
                        <ul ref={scrl} onScroll={scrollCheck} className='ul-list'>
                            {tours.map((d)=>{
                                return(
                                    <div className='li-list' style={{height:'auto'}}>
                                        <Card className='shadow-sm rounded'>
                                            <li key={d.id} >
                                                <a href={d.url} className='stretched-link position-relative' style={{textDecoration:'none'}}>
                                                    <img src={d.src}/>
                                                    <h5 className='text-center align' style={{color:'black'}}>{d.caption}</h5>
                                                    <p className='text-center align' style={{color:'black'}}>{d.location}</p>
                                                </a>
                                                
                                            </li>
                                        </Card>
                                    </div>
                                )            
                            })}
                        </ul>
                    </div>   
                </div>

                {scrollX !== -1 && (
                <div className='arrow-right' style={{marginTop:'-5%'}}>
                    <Button onClick={()=>slide(+300)} color='neutral'>
                        <i className='now-ui-icons arrows-1_minimal-right'/>
                    </Button>
                </div>
                )}
            </div>
        </Container>
        
        </>
    )
}

export default HorizontalScroll